/**
 * Reading DATEONLY columns, which arrive from the API as a bare 'yyyy-MM-dd'
 * string with no time and no zone.
 *
 * DateUtil cannot be used for these: formatFromDB parses the bare string as
 * LOCAL midnight and then re-renders it in UTC, which lands on the previous day
 * for anyone at a non-negative UTC offset. Correct for every US timezone and
 * silently wrong elsewhere — and for a year that means the wrong year every
 * January 1st. A calendar date has no zone, so don't involve one.
 */

/**
 * '2026-03-01' -> '2026'. Returns '' for anything unparseable.
 *
 * The provider's inactive date is stored in full but only ever shown as a year:
 * liaisons know the season someone left, not the day, and a precise-looking
 * date invites a precision the data does not have.
 */
export const yearFromDateOnly = (value) => {
  const match = /^(\d{4})-\d{2}-\d{2}/.exec(String(value || ''));
  return match ? match[1] : '';
};

export default { yearFromDateOnly };
